import { getLocalisedDateProperty } from '../utils/get-localised-date-property';
import { padNumberToLength } from '../utils/pad-number-to-length';
/**
 * Returns a numerical representation of the month: 1, 2, ..., 12
 * @hidden
 */
export const getMonthNumeric = ({ offsetUtcDate }) => {
    return offsetUtcDate.getUTCMonth() + 1;
};
/**
 * Returns an ordinal string representation of the month: 1st, 2nd, ..., 12th
 * @hidden
 */
export const getMonthOrdinal = (params) => {
    const month = getMonthNumeric(params);
    return params.ordinalStringFormatter(month);
};
/**
 * Returns a two-digit string representation of the month: 01, 02, ..., 12
 * @hidden
 */
export const getMonthTwoDigit = (params) => {
    const month = getMonthNumeric(params);
    return padNumberToLength(month, 2);
};
/**
 * Returns a short localised string representation of the month: Jan, Feb, ..., Dec
 * @hidden
 */
export const getMonthShort = (params) => {
    return getLocalisedDateProperty({
        date: params.date,
        languageTag: params.languageTag,
        ianaTimeZoneName: params.ianaTimeZoneName,
        property: 'month',
        format: 'short'
    });
};
/**
 * Returns a long localised string representation of the month: January, February, ..., December
 * @hidden
 */
export const getMonthLong = (params) => {
    return getLocalisedDateProperty({
        date: params.date,
        languageTag: params.languageTag,
        ianaTimeZoneName: params.ianaTimeZoneName,
        property: 'month',
        format: 'long'
    });
};
//# sourceMappingURL=month.js.map